// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import {appRouter} from './router/appRouter'

import ElementUI from 'element-ui'
import 'default-passive-events'
import jq from 'jquery'
Vue.prototype.$jq = jq;
import 'element-ui/lib/theme-chalk/index.css'

// 自己写的样式
import '../static/css/theme.css'
import '../static/css/theme-primary.css'
import '../static/css/character.css'
import '../static/css/shopping_cart.css'
import '../static/css/layout.css'
import { toastSuccess, toastError, toastWarning } from "./components/common/toast.js";

Vue.prototype.$toastSuccess = toastSuccess;
Vue.prototype.$toastError = toastError;
Vue.prototype.$toastWarning = toastWarning;



import VueDOMPurifyHTML from 'vue-dompurify-html'

Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_TAGS: ['iframe','span'], // this one whitelists Youtube， 既防止 xss估计，又保证 iframe正常显示
    ALLOWED_ATTR: ['target','href','src','class', 'style'],
    // hooks: {
    //   afterSanitizeAttributes: (currentNode) => {
    //     // console.log("哈哈哈哈", currentNode)
    //     if('target' in currentNode){
    //       this.$set(currentNode,'target','_blank')
    //       // currentNode.setAttribute("target","_blank");
    //     }
    //   },
    //   beforeSanitizeAttributes:(node)=>{
    //     // console.log("喜喜",node)
    //   }
    // } 
  },
})


import VueDPlayer from "vue-dplayer";
import "vue-dplayer/dist/vue-dplayer.css";
Vue.use(VueDPlayer);



let bus = new Vue();
Vue.prototype.$bus = bus

// import 'lib-flexible' // 不好用




import './assets/styles/quill.core.css'
import './assets/styles/quill.snow.css'
import './assets/styles/quill.bubble.css'
import './assets/styles/quillEditor.css'

// 全局引入思源字体
import '@/assets/fonts/siyuan_font.css'
import '@/assets/fonts/sans_font.css'

Vue.use(ElementUI)

Vue.config.productionTip = false

import * as request from "./api/request.js";
Vue.prototype.$request = request;

import {pinyinUtil} from './utils/pinyin_withtone.js'

Vue.prototype.$pyTool = pinyinUtil;

import tool from "./utils/tool";
Vue.use(tool);

import * as  timeUtils from './utils/time_util.js'
Vue.prototype.$timeUtils = timeUtils
// vuex 

// import Vuex
import store from './store'

// 复制到剪贴板
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import * as  localStore from './store/localstore.js'
Vue.prototype.$localStore = localStore;

// window.addEventListener('popstate', function() {
//   history.pushState(null, null, document.URL)
// })

import i18n from './lang'

// import vConsole from '@/utils/vconsole.js'
// Vue.prototype.vConsole = vConsole;

// // 图片压缩插件
// import ImageComparessor from 'vue-image-compressor'

// Vue.use(ImageComparessor)
// Vue.prototype.$localStore = ImageComparessor;
/* eslint-disable no-new */


import VueLazyload from 'vue-lazyload'
//注意内容中引用图片路径:src要改为:v-lazy(使用时一定给一个 key 属性)
Vue.use(VueLazyload, {
  // loading: require('./assets/images/loading.png'),
  // error: require('./assets/img/common/error.png'),
})

import moment from 'moment'
Vue.prototype.$moment = moment

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next)=>{
  if(to.fullPath == "/promotion"){
    if(this.checkPromotionPermission()){
      next()
    }
  }
  next()
})

router.afterEach((to,from)=>{
  // console.log('to',to.fullPath);
  if(to.fullPath == '/'){
    router.push({name:'mainpage'})
  }
})
Vue.directive('permission',{
  inserted(el,binding){
    if(!binding.value){
      el.parentNode.removeChild(el)     
    }
  }
})

export function checkPromotionPermission()
{
  let check =  JSON.parse(sessionStorage.getItem("PromotionLoginChecked"))
  let login =  JSON.parse(sessionStorage.getItem("PromotionLoginChecked"))
 
  return check && login
}


// WEBPACK FOOTER //
// ./src/main.js